var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[(_vm.err)?_vm._t("error",function(){return [_vm._v("Something went wrong")]},{"err":_vm.err,"vm":_vm.vm,"info":_vm.info}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }